import { NumericFormat } from 'react-number-format';
// import { Input } from '../../../styles/component.styles'; // optional

const InputCurrency = ({ value = 0, onChange, placeholder = 'Currency', maxCents }) => {
  const handleValueChange = ({ floatValue }) => {
    const cents = Math.round((floatValue || 0) * 100);
    const clamped = typeof maxCents === 'number' ? Math.min(cents, maxCents) : cents;
    onChange(clamped);
  };

  return (
    <NumericFormat
      value={value / 100}
      onValueChange={handleValueChange}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      placeholder={placeholder}
      inputMode="decimal"
      // customInput={Input} // optional styling
    />
  );
};

export default InputCurrency;